import { Button, Icon } from 'ui';

type P = {
  onShowComments?: () => void;
};

const CommentButton = ({ onShowComments }: P) => (
  <Button icon={<Icon icon="chat-3-line" />} onClick={onShowComments} type="text">
    Comment
  </Button>
);

export default CommentButton;
